<template>
    <div class="container">
        <div class="header">
            <div class="heading">
                <img v-if="viewMode" class="backArrow" src="../../assets/backArrow.svg" @click="onBackClick"/>
                <p v-if="!viewMode" class="title">Link Request</p>
                <p  v-else class="title">{{agencyName}} <span class="subTitle">ID: {{agencyId}} </span> </p>
            </div>
            <div style="display: flex; align-items: center">
                <p class="download" @click="downloadBrands">View Linked Brands </p>
                <button class="submitBtn" @click="handleSubmit">{{viewMode ? 'Link' : 'Create request'}}</button>
            </div>
        </div>
        <div class="form">
            <div v-if="apiErrorMessage" class="errorContainer"> 
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <div v-if="viewMode">
                <div  class="label">Brand Name*</div>
                <div class="content"> 
                    <input class="textbox" :disabled="viewMode" v-model="brandName" placeholder="Enter here" />
                </div>
            </div>
            <div>
                <div  class="label">Brand Id*</div>
                <div class="content"> 
                    <input class="textbox" :disabled="viewMode" v-model="brandId" @blur="validateBrandId" placeholder="Enter here" />
                    <p v-if="fieldErrors?.brandId" class="label" style="color: red">{{fieldErrors.brandId}}</p>
                </div>
            </div>
        </div>
        <div class="form">
            <div class="subHeading">Linking History </div>
            <table class="table">
                <thead style="background: #F5F5F5">
                    <tr>
                        <th class="tableHead">Brand Name</th>
                        <th>Request Timestamp<img alt="img" style="cursor: pointer"
                                                @click="onSortClick" src="../../assets/Vector.svg" /></th>
                        <th>Status</th>
                        <th>Action Timestamp<img alt="img" style="cursor: pointer"
                                                @click="onApprovedSortClick" src="../../assets/Vector.svg" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredItems" :key="item.brandId">
                        <td>
                            <div style="font-size: 12px; font-weight: 600; color: #41434C"> {{ item.brandName }} </div>
                            <div style="font-size: 12px; margin-top: 4px">ID: {{ item.brandId }} </div>
                        </td>
                        <td>{{ formatDate(item.timeStamp) }}</td>
                        <td><button class="status" :style="`border: 1px solid ${getColor(item.status)}; color: ${getColor(item.status)}`"> {{item.status}} </button></td>
                        <td>{{ formatDate(item.approvedTimeStamp) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="paginate">
                <div class="rows">
                    <span class="paginationText">Page {{ currentPage }} of {{ isNaN(totalPages) ? 1 :
                        totalPages }}</span>
                    <div class="flexClass">
                        <p class="paginationText">Rows per page</p>
                        <select class="limit" v-model="rowsPerPage" @change="onRowsPerPageChanged">
                            <option v-for="option in options" v-bind:key="option" :value="option">{{ option }}
                            </option>
                        </select>
                        <img alt="img" v-if="currentPage > 1" @click="prevPage" class="leftArrow"
                            src="../../assets/leftArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/leftArrow.svg" />
                        <img alt="img" v-if="currentPage < totalPages" @click="nextPage" class="rightArrow"
                            src="../../assets/rightArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/rightArrow.svg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCookie } from "@/services/campaignService";
import { agencyBrandLink, getLinkedBrands, getLinkHistoryList, linkRequest } from "@/services/selfServeService";
import moment from "moment";
import { toRaw } from "vue";


export default ({
    name: 'Link',
    props: {
        viewMode: Boolean,
        item: Object,
    },
    data() {
        return {
            brandId: this.item?.brandId ?? '',
            brandName: this.item?.brandName ?? '',
            agencyId: this.item?.agencyId ?? '',
            agencyName: this.item?.agencyName ?? '',
            fieldErrors: {
                brandId: '',
            },
            apiErrorMessage: '',
            items: [],
            currentPage: 1,
            rowsPerPage: 5,
            sortClicked: false,
            approvedSortClicked: false,
            options: [5, 10, 15],
        }
    },
    mounted() {
        this.getHistoryList()
    },
    methods: {
        getColor(status) {
            if(status == 'APPROVED') return '#0A5F23'
            else if(status == 'REJECTED' || status == 'DELINKED') return '#CD0909'
            return '#F5A300'
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
            }
            return value
        },
        onSortClick() {
            this.sortClicked = !this.sortClicked;
            this.items?.sort((a, b) => {
                    let dateA = new Date(a.timeStamp) ;
                    let dateB = new Date(b.timeStamp) ;
                    return this.sortClicked ? dateB - dateA :  dateA - dateB;
            })
        },
        onApprovedSortClick() {
            this.approvedSortClicked = !this.approvedSortClicked;
            this.items?.sort((a, b) => {
                    let dateA = new Date(a.approvedTimeStamp) ;
                    let dateB = new Date(b.approvedTimeStamp) ;
                    return this.approvedSortClicked ? dateB - dateA :  dateA - dateB;
            })
        },
        nextPage() {
            this.currentPage++
        },
        prevPage() {
            this.currentPage--
        },
        validateBrandId() {
            const userIdPattern = /^[0-9]+$/;
            this.fieldErrors.brandId = !userIdPattern.test(this.brandId) ? 'Brand ID is invalid' : ''
        },
        validateForm() {
            this.validateBrandId();
            return !this.fieldErrors.brandId;
        },
        handleSubmit() {
            this.apiErrorMessage = null;
            if(!this.viewMode) {
                if(this.validateForm()) {
                    const payload = {
                        brandId: this.brandId,
                    }
                    linkRequest(payload)
                        .then(res => res.json())
                        .then(data => {
                            if(data.code == 200) {
                                this.$router.push('/')
                            } else {
                                this.apiErrorMessage = data?.errors?.[0] || data?.message
                            }
                        })
                        .catch(data => {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        })
                }
            } else {
                const payload = {
                    agency_id: this.item.agencyId,
                    brand_id: this.item.brandId,
                    approval_status: 'ACCEPTED',
                    is_delink: false,
                }
                agencyBrandLink(payload)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.onBackClick();
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    })
            }
        },
        onBackClick() {
            this.$emit('backClicked')
        },
        async getHistoryList() {
            await getLinkHistoryList()
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.items = data?.data;
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    })
        },
        async downloadBrands() {
            this.apiErrorMessage = null;
            const agencyId = getCookie('userId')
            await getLinkedBrands(agencyId)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            const content = [{brandId: 'Brand ID', brandName: 'Brand Name'}, ...data?.data]
                            const csvContent = "data:text/csv;charset=utf-8," +
                            content?.map(row => Object.values(row).join(',')).join('\n');
                            const link = document.createElement('a');
                            link.href = encodeURI(csvContent);
                            link.target = '_blank';
                            link.download = `brands.csv`;
                            link.click();
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    })
        }
    },
    computed: {
        totalPages() {
            let newpages = 0;
            newpages = Math.ceil(toRaw(this.items)?.length / this.rowsPerPage)

            if (this.currentPage !== 1 && this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            newpages = Math.max(newpages, 1);
            return newpages;
        },
        filteredItems() {
            let pageNumber = this.currentPage === 0 ? 1 : this.currentPage;
            const start = (pageNumber - 1) * this.rowsPerPage;
            const end = start + this.rowsPerPage;
            return this.items?.slice(start, end);
        },
        onRowsPerPageChanged() {
            const oldRowsPerPage = this.rowsPerPage;
            this.rowsPerPage = Number(event.target.value);
            this.totalPages = Math.ceil(this.campaigns?.length / this.rowsPerPage);
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            if (oldRowsPerPage !== this.rowsPerPage) {
                this.$nextTick(() => {
                    const newPage = Math.floor(((this.currentPage - 1) * oldRowsPerPage) / this.rowsPerPage) + 1;
                    this.currentPage = newPage;
                });
            }
        }
    },
})
</script>

<style scoped>
.container {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}
.title{
    margin-left:20px;
}
.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}
.submitBtn {
    background: #2E31BE;
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9.5px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    border: none;
    height: 40px;
}
.form {
    display: flex;
    flex-direction: column;
    margin: 1%;
    text-align: start;
    background: #FFFFFF;
    padding: 22px 24px 36px;
    border-radius: 12px;
}
.content{
    height: 100%;
}
.textbox{
    width: 274px;
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    max-width: 246px;
}
.label{
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    margin-bottom: 12px;
    margin-top: 16px;
}
.text {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
}
.textbox:disabled {
  background-color: #E0E0E0;
}
.backArrow {
    cursor: pointer;
}
.subTitle{
    font-size: 14px;
    font-weight: 600;
    color: #666666;
    margin-left: 8px;
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
        font-size: 18px;
        text-align: left;
    }

    th {
        color: #41434C;
        padding: 12px 15px;
        /* width: 150px; */
        font-size: 14px;
        font-weight: 600;
    }
    td {
        padding: 12px 15px;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #5C5C5C;
        width: 150px;
    }

    thead tr {
        text-align: left;
        font-weight: bold;
    }

    tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    tbody tr:nth-of-type(even) {
        background-color: #F5F8FF;
    }
    .paginate {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        gap: 715px;
        height: 66px;
        left: 274px;
        top: 775px;
        background: #FFFFFF;
        border: 1px solid #F8F8F8;
        width: -webkit-fill-available;
    }
    .rows {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.flexClass {
    display: flex;
}

.limit {
    display: flex;
    margin-left: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #666666;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 10px 8px 10px 12px;
}

.leftArrow {
    display: flex;
    margin-left: 24px;
    cursor: pointer;
}

.leftArrowDisabled {
    display: flex;
    margin-left: 20px;
    opacity: 0.4;
    cursor: not-allowed;
}

.rightArrow {
    display: flex;
    margin-left: 20px;
    cursor: pointer;
}
.paginationText {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #9B9B9B;
}
.status {
        width: 91px;
        height: 21px;
        padding: 1px 4px 1px 4px;
        border-radius: 4px;
        font-size: 12px;
        background: #fff;
    }
.subHeading {
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
    color: #666666;
    margin-top: 16px;
}
.download {
    cursor: pointer;
    margin-right: 24px;
    color: #2E31BE;
    font-size: 14px;
}
</style>
